import { useSelector } from "react-redux";

import { CompetitorTrafficShare } from "app/pages/benchmark-tracker/components/Report/MetricElements/TrafficShare/CompetitorTrafficShare/CompetitorTrafficShare";
import { MyTrafficShare } from "app/pages/benchmark-tracker/components/Report/MetricElements/TrafficShare/MyTrafficShare/MyTrafficShare";
import type { ComponentSchema } from "app/pages/benchmark-tracker/components/Report/Tab/types";
import { selectMetricByName } from "app/pages/benchmark-tracker/store/selectors/reportSelectors";
import type { BenchmarkMetricName, TrafficShareMetricSchema } from "app/pages/benchmark-tracker/types/api.types";

import { Wrapper } from "./styles";

type TrafficShareSchema = {
    tooltip: ComponentSchema["tooltip"];
    secondaryTooltip: ComponentSchema["secondaryTooltip"];
    onOpenModal: ComponentSchema["onOpenModal"];
    name: BenchmarkMetricName;
};

export const TrafficShare = ({ tooltip, secondaryTooltip, name, onOpenModal }: TrafficShareSchema) => {
    const data = useSelector(selectMetricByName<TrafficShareMetricSchema>(name));

    if (!data) {
        return null;
    }

    const { primaryData, isLoading } = data;

    return (
        <Wrapper>
            <MyTrafficShare
                tooltip={secondaryTooltip ?? ""}
                shareTrend={primaryData?.shareTrend ?? []}
                pop={primaryData?.periodOverPeriodShareDifference ?? 0}
                share={primaryData?.share ?? 0}
                yoy={primaryData?.yearOverYearShareDifference ?? 0}
                isLoading={isLoading ?? false}
            />

            <CompetitorTrafficShare
                tooltip={tooltip ?? ""}
                trafficShareData={data}
                isLoading={isLoading ?? false}
                onOpenModal={() => onOpenModal?.(name)}
            />
        </Wrapper>
    );
};
